import TableInput from 'components/elements/table/table-input';
import useHotelScheduleTableList from 'legacy-modules/cro/hooks/use-hotel-schedule-table-list';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import {
  HotelScheduleDetailFormType,
  HotelScheduleFormType,
} from './hotel-schedule-form-type';

const name = 'hotelSchedules' as const;

export default function HotelScheduleTable() {
  const { control, getValues, clearErrors } =
    useFormContext<HotelScheduleFormType>();

  const { fields, update } = useFieldArray({
    name,
    keyName: 'customId',
    control,
  });

  const columns = useHotelScheduleTableList('editable');

  const dispatch = React.useCallback(
    (action) => {
      const currentRowIndex = action.rowIndex;
      const details = getValues(name) as HotelScheduleDetailFormType[];
      const detail = details[currentRowIndex];
      const columnId = action.columnId as keyof HotelScheduleDetailFormType;
      // const extra = action.extra as Value;

      const otherVal: () => Partial<HotelScheduleDetailFormType> = () => {
        return {};
      };

      if (action.type === 'update_cell') {
        const row = {
          ...detail,
          [action.columnId]: action.value,
          ...otherVal(),
        };

        update(currentRowIndex, row);

        clearErrors(`${name}.${currentRowIndex}.${columnId}`);
      }
    },
    [clearErrors, getValues, update],
  );
  const height = 'calc(100dvh - 120px - 64px - 48px)';
  return (
    <TableInput
      data={fields}
      columns={columns}
      name={name}
      dispatch={dispatch}
      noAddRemoveRow
      uniqueRowKey="id"
      tableContainerStyle={{
        minHeight: height,
        maxHeight: height,
      }}
    />
  );
}
